/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React from 'react';
import { Dimensions, StyleSheet, TouchableOpacity, View } from 'react-native';
import { isWeb } from '@global/screens';

function ActivityList({ children, left, right, bottom = false, onPress }) {
  return (
    <TouchableOpacity onPress={() => onPress()}>
      {!left && !right ? (
        children
      ) : (
        <View style={styles.container}>
          <View>{left}</View>
          <View
            style={
              isWeb
                ? { maxWidth: 'calc(100% - 40px)' }
                : { width: Dimensions.get('screen').width - 125 }
            }>
            {right}
            {bottom}
          </View>
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

export default ActivityList;
